import { render, staticRenderFns } from "./AnswerDate.vue?vue&type=template&id=780166c6&"
import script from "./AnswerDate.vue?vue&type=script&lang=js&"
export * from "./AnswerDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports